export const getShowSpinnerAction = (state = false, action) => {
  switch (action.type) {
    case "SHOW_SPINNER":
      return action.data;

    default:
      return state;
  }
};
